import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Tenant} from '../../models/tenant/tenant';
import {FabricService} from 'src/app/services/fabric/fabric.service';
import {tap} from 'rxjs/operators';
import {TenantCostMetric, TenantDetailCostMetric} from 'src/app/models/cost/tenant-cost-metric';

const SERVICE_NAME = 'mp-cost-management-resource';

@Injectable({
  providedIn: 'root'
})
export class CostMgmtService {

  constructor(private fabricService: FabricService) {

  }

  getTenantsWiseCostMetric(): Observable<TenantCostMetric[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get-cost-mgmt-tenant-cost')
      .pipe(tap(costmetric => costmetric.forEach(this.convertModel)));
  }

  getTenantDetailCostMetric(tenant: string): Observable<TenantDetailCostMetric> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get-cost-mgmt-tenant-tenantId-cost', {tenantId: tenant});
  }

  approveTenant(request: any): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post-tenant-mgmt-approve-tenants-tenant-id-approve', request);
  }

  convertModel(tenant: TenantCostMetric) {

  }

}
